var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKabxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 58,
    viewBox: "0 0 228 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.91 36.3802L200.27 57.5402L214.9 57.4702L198.54 36.3102L214.69 14.9902L200.06 15.0602L183.91 36.3802Z",
    fill: "#1DA3F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.58 42.5002L16.67 28.5202L9.46997 34.9302V42.5002H0V9.99023H9.46997V25.0402L26.09 9.99023H37.89L23.45 22.9502L38.73 42.5002H27.59H27.58Z",
    fill: "#00004F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5502 36.27H61.7202L58.6602 42.49H48.7202L65.5302 9.97998H75.8902L92.7002 42.49H82.6202L79.5502 36.27ZM76.2502 29.54L70.6302 18.02L64.9602 29.54H76.2402H76.2502Z",
    fill: "#00004F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.81 33.5802C140.81 39.2002 135.75 42.5002 127.76 42.5002H102.64V9.99023H125.9C133.89 9.99023 138.95 13.1902 138.95 18.4002C138.95 22.0702 136.4 25.2702 131.52 25.5502C136.63 25.8702 140.81 28.5702 140.81 33.5802ZM112.02 22.9502H124.33C127.49 22.9502 129.58 22.2502 129.58 19.7502C129.58 17.2502 127.49 16.5902 124.33 16.5902H112.02V22.9502ZM131.1 32.4702C131.1 29.8202 129.1 29.0802 125.76 29.0802H112.01V35.9102H125.76C129.1 35.9102 131.1 35.1202 131.1 32.4702Z",
    fill: "#00004F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.91 26.24L168.83 52.49H150.75L170.84 26.24L150.75 0H168.83L188.91 26.24Z",
    fill: "#E60000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.47 15.0298V15.6198H219.69V19.9898H218.97V15.6198H217.19V15.0298H221.47Z",
    fill: "#1DA3F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.11 15.0298H223.13L224.65 19.2298L226.16 15.0298H227.18V19.9898H226.5V17.0598C226.5 16.9598 226.5 16.7898 226.5 16.5598C226.5 16.3298 226.5 16.0698 226.5 15.8098L224.99 19.9998H224.28L222.76 15.8098V15.9598C222.76 16.0798 222.76 16.2698 222.77 16.5198C222.77 16.7698 222.78 16.9498 222.78 17.0698V19.9998H222.1V15.0398L222.11 15.0298Z",
    fill: "#1DA3F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabxLogo);
export default __webpack_public_path__ + "static/media/KABX_logo.218b74eeab13336280b4855c027d3768.svg";
export { ForwardRef as ReactComponent };